import * as actions from "../action.constants";

const initialState = {
  templates: [],
  timezones: [],
  analysis: {},
  sensor: {},
  snapshots: [],
};

const storeTemplates = (state, action) => {
  return {...state, templates: action.payload || []};
};

const storeAnalysis = (state, action) => {
  return {...state, analysis: action.payload};
};

const storeSensorAnalysis = (state, action) => {
  return {...state, sensor: action.payload};
};

const storeTimezones = (state, action) => {
  return {...state, timezones: action.payload || []};
};

const storeSnapshot = (state, action) => {
  return {...state, snapshots: action.payload || []};
};

const handlers = {
  [actions.STORE_DATA_EXPLORER_TEMPLATES]: storeTemplates,
  [actions.STORE_DATA_EXPLORER_ANALYSIS]: storeAnalysis,
  [actions.STORE_DATA_EXPLORER_SENSOR_ANALYSIS]: storeSensorAnalysis,
  [actions.STORE_DATA_EXPLORER_TIMEZONES]: storeTimezones,
  [actions.STORE_DATA_EXPLORER_SNAPSHOT]: storeSnapshot,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
